<template>
  <fullstory-manager ref="fullstoryRef" />
</template>

<script>
import config from "@/config";
import store from "@/store";

export default {
  name: 'FullStoryInitializer',

  beforeMount() {

    window.FullStoryConfig = {
      organizationId: store.getters.getOrgID(),
      userId: store.getters.getUserID(),
      fullStoryOrgKey: config.FS_ORG_ID,
      userName: store.getters.getUserFullName(),
      userEmail: store.getters.getUserEmail(),
		nonce: config.CSP_NONCE,
      getToken: () => {
		 const token =  store.getters.getAccessToken()
		  // Fullstory expects the token to be in the format "Bearer <token>"
		 return token.split('Bearer ')[1]
	  },
    };
  },

  mounted() {
    const managerElement = this.$refs.fullstoryRef;

    if (managerElement) {
      managerElement.setAttribute('config', 'FullStoryConfig');
    }
  }
}
</script>